import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Calendar } from 'lucide-react';
import ScheduleDemoDialog from './ScheduleDemoDialog';
import { handleScrollReset } from '@/utils/navigationUtils';

const SaasHero: React.FC = () => {
  const [isScheduleDialogOpen, setIsScheduleDialogOpen] = useState(false);
  
  return (
    <div className="bg-gradient-to-r from-blue-900 to-indigo-800 text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="text-center md:text-left md:flex md:items-center md:justify-between">
          <div className="md:w-3/5 md:pr-8">
            <h1 className="text-4xl lg:text-5xl font-extrabold tracking-tight mb-6">
              Launch Your Own <span className="text-blue-300">Referral Program</span> Business
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-blue-100">
              Our white-label platform lets you build and scale a profitable referral program business with minimal setup time.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
              <Link to="/business-reseller-order">
                <Button size="lg" className="bg-white text-blue-900 hover:bg-blue-50">
                  Get Started
                </Button>
              </Link>
              <Button 
                size="lg" 
                variant="outline" 
                className="text-white border-white hover:bg-blue-800"
                onClick={() => setIsScheduleDialogOpen(true)}
              >
                <Calendar className="mr-2 h-5 w-5" />
                Schedule Demo
              </Button>
            </div>
            <div className="mt-4 space-x-6">
              <Link to="/blog" className="text-blue-200 hover:text-white underline underline-offset-4">
                Read Our Blog
              </Link>
              <Link 
                to="/saas-reseller" 
                className="text-blue-200 hover:text-white underline underline-offset-4"
                onClick={handleScrollReset}
              >
                View Pricing
              </Link>
            </div>
          </div>
          <div className="hidden md:block md:w-2/5">
            <div className="bg-white p-4 rounded-lg shadow-xl">
              <img 
                src="/assets/36c87bd9-7bdf-4413-bf74-70043278eb04.png" 
                alt="Referral Program Dashboard" 
                className="rounded"
              />
            </div>
          </div>
        </div>
      </div>
      
      {/* Schedule Demo Dialog */}
      <ScheduleDemoDialog 
        open={isScheduleDialogOpen} 
        onOpenChange={setIsScheduleDialogOpen} 
      />
    </div>
  );
};

export default SaasHero;
